import type { RootState } from "@/store"

const selectIsPlayerLoaded = () => (state: RootState) =>
  state.player.isPlayerLoaded
const selectIsAuthorized = () => (state: RootState) => state.player.isAuthorized

export const PlayerSelectors = { selectIsPlayerLoaded, selectIsAuthorized }
